import { useQuery } from '@tanstack/react-query';
import { zohoApi } from '../services/api';

/**
 * Dernière facture d'un vendor Zoho (utilisée comme template à la duplication).
 * Cache 2 min seulement : si on vient de valider une facture pour ce vendor,
 * la prochaine doit refléter rapidement le nouveau modèle.
 */
export function useZohoLastBill(vendorId: string | null | undefined) {
  return useQuery({
    queryKey: ['zoho-last-bill', vendorId],
    queryFn: () => {
      if (!vendorId) throw new Error('vendorId requis');
      return zohoApi.lastBill(vendorId);
    },
    enabled: Boolean(vendorId),
    staleTime: 2 * 60_000,
  });
}
